import { z } from 'zod';
import { idParamSchema } from './common';

const MAX_NAME_LENGTH = 100;
const MAX_VALUE_LENGTH = 32 * 1024; // 32 Ki UTF-16 code units
const MAX_TAGS = 20;
const MAX_TAG_LENGTH = 50;
const MAX_SCOPE_HUBS = 100;
const MAX_SCOPE_TAGS = 50;

export const vaultSecretScopeSchema = z.object({
  hubs: z.array(z.string().min(1)).max(MAX_SCOPE_HUBS).optional(),
  tags: z.array(z.string().min(1).max(MAX_TAG_LENGTH)).max(MAX_SCOPE_TAGS).optional(),
}).strict();

export const vaultCreateBody = z.object({
  name: z.string().trim().min(1, 'name is required').max(MAX_NAME_LENGTH, `name must be ${MAX_NAME_LENGTH} characters or fewer`),
  value: z.string().min(1, 'value is required').max(MAX_VALUE_LENGTH, `value must be ${MAX_VALUE_LENGTH} characters or fewer`),
  tags: z.array(z.string().min(1).max(MAX_TAG_LENGTH, `Tag must be ${MAX_TAG_LENGTH} characters or fewer`)).max(MAX_TAGS, `Maximum ${MAX_TAGS} tags allowed`).optional().default([]),
  scope: vaultSecretScopeSchema.optional().default({}),
}).strict();

export const vaultUpdateBody = z.object({
  name: z.string().trim().min(1).max(MAX_NAME_LENGTH).optional(),
  value: z.string().min(1).max(MAX_VALUE_LENGTH).optional(),
  tags: z.array(z.string().min(1).max(MAX_TAG_LENGTH)).max(MAX_TAGS).optional(),
  scope: vaultSecretScopeSchema.optional(),
}).strict();

export const vaultIdParam = idParamSchema;

export type VaultCreateBody = z.infer<typeof vaultCreateBody>;
export type VaultUpdateBody = z.infer<typeof vaultUpdateBody>;
export type VaultIdParam = z.infer<typeof vaultIdParam>;

export const VAULT_LIMITS = {
  MAX_NAME_LENGTH,
  MAX_VALUE_LENGTH,
  MAX_TAGS,
  MAX_TAG_LENGTH,
  MAX_SCOPE_HUBS,
  MAX_SCOPE_TAGS,
} as const;
